import {connect} from 'react-redux';

import {
  AppParametricSelector,
  createSelector,
  makeMapStateToProps,
} from '../../../../../srcCommon/helpers/reselectHelpers';
import {CalendarModel} from '../../../../models/api/calendarModel';
import {CalendarVersionModel} from '../../../../models/api/calendarVersionModel';
import {makeGetCalendarData} from '../../../../store/data/calendarVersions/calendarVersionsSelectors';
import {
  getMeetingProperties,
  getSchedulingCalendarVersionId,
} from '../../../../store/panels/calendars/scheduling/calendarsPanelSchedulingSelectors';
import {CalendarsPanelId} from '../../../../store/panels/panelStateBase';
import {SchedulingLinkMeetingSettings} from './schedulingLinkMeetingSettings';

/*
 * Props.
 */

interface SchedulingLinkMeetingSettingsContainerProps {
  panelId: CalendarsPanelId;
}

/*
 * Selectors.
 */

interface CalendarData {
  calendar: CalendarModel;
  calendarVersion: CalendarVersionModel;
}

const makeGetSupportedProviderConferenceTypes = (getCalendarData: AppParametricSelector<any, CalendarData>) =>
  createSelector([getCalendarData], (calendarData) => calendarData.calendar.supportedProviderConferenceTypes);

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<SchedulingLinkMeetingSettingsContainerProps>()(() => {
  const getCalendarData = makeGetCalendarData(getSchedulingCalendarVersionId);
  return {
    meetingProperties: getMeetingProperties,
    supportedProviderConferenceTypes: makeGetSupportedProviderConferenceTypes(getCalendarData),
    schedulingCalendarVersionId: getSchedulingCalendarVersionId,
  };
});

export const SchedulingLinkMeetingSettingsContainer = connect(mapStateToProps)(SchedulingLinkMeetingSettings);
